import Vue from 'vue'
import { loadLanguageAsync } from './locales'

async function main () {
  const i18n = await loadLanguageAsync()

  window.app = {
    $t: i18n.t.bind(i18n)
  }

  const { router, store, App } = await import('./mount').catch(e => {
    console.error(e)
  })

  window.app = new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

main()



// WEBPACK FOOTER //
// ./src/main.js